import Delete from "@mui/icons-material/Delete";
import { Box, InputAdornment, TextField } from "@mui/material";
import Search from "@mui/icons-material/Search";
import {
  GridActionsCellItem,
  GridColDef,
  GridRowParams,
} from "@mui/x-data-grid-premium";
import { DataGridWithDefaultSort } from "components/DataGridWithDefaultSort";
import { JobStepsDone } from "generated-graphql/graphql";
import { useMemo, useState } from "react";

export interface StepsDoneTabProps {
  stepsDone: JobStepsDone[];
  onDeleteStep: (step: JobStepsDone) => void;
}

export function StepsDoneTab({ stepsDone, onDeleteStep }: StepsDoneTabProps) {
  const [search, setSearch] = useState("");

  const filteredSteps = useMemo(() => {
    if (!search.trim()) {
      return stepsDone;
    }
    const lower = search.toLowerCase();
    return stepsDone.filter((step) =>
      (step.name ?? "").toLowerCase().includes(lower)
    );
  }, [stepsDone, search]);

  const columns: GridColDef<JobStepsDone>[] = useMemo(
    () => [
      {
        field: "name",
        headerName: "Name",
        flex: 0.75,
      },
      {
        field: "actions",
        type: "actions",
        headerName: "",
        width: 60,
        sortable: false,
        filterable: false,
        disableColumnMenu: true,
        getActions: (params: GridRowParams<JobStepsDone>) => [
          <GridActionsCellItem
            key="delete"
            icon={<Delete />}
            label="Delete"
            onClick={() => onDeleteStep(params.row)}
          />,
        ],
      },
    ],
    [onDeleteStep]
  );

  return (
    <Box>
      <TextField
        size="small"
        placeholder="Search step name..."
        value={search}
        onChange={(e) => setSearch(e.target.value)}
        sx={{ mb: 2, maxWidth: 320 }}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <Search fontSize="small" color="action" />
            </InputAdornment>
          ),
        }}
      />
      <DataGridWithDefaultSort
        autoHeight
        hideFooter
        sortModel={[{ field: "createdAt", sort: "desc" }]}
        columns={columns}
        rows={filteredSteps}
      />
    </Box>
  );
}
